<span class="threepl-toolbar-icon-button" container="body" placement="left" [ngbTooltip]="'View Settings' | translate">
  <bz-button variant="tertiary" size="fit" class="show-button"
             appBringozIdGenerator="threepl-services-settings-button"
             [ariaLabel]="'View Settings' | translate"
             (clicked)="onOpen($event)">
    <bz-icon class="threepl-toolbar-icon" [icon]="icon"></bz-icon>
  </bz-button>
</span>
